export const DISPLAY_STEP = 5;

export const STATE_PENDING = 1;
export const STATE_VALID = 2;
export const STATE_INVALID = 4;

export const PAYMENT_DELAY = 21;

export const DEFAULT_FILTER_VALUE = -1;



// WEBPACK FOOTER //
// ./src/constants/payment.js